import { getBusinessErrorCode, getErrorCode } from '@/lib/error-utils';

/** 与后端费用准入码对齐；不依赖错误文案推断扣费范围。 */
const BILLING_ERROR_MESSAGES = {
  PROJECT_BUDGET_REQUIRED: '尚未配置项目预算，请联系管理员。',
  PROJECT_BUDGET_INSUFFICIENT: '项目预算不足，请调整后重试。',
  CONTRACT_BUDGET_INSUFFICIENT: '承制预算不足，请调整后重试。',
  CONTRACT_BUDGET_NOT_CONFIGURED: '尚未配置承制预算，请联系管理员。',
  HOST_BUDGET_INSUFFICIENT: '主办方项目预算不足，请联系管理员。',
  AI_SESSION_INSUFFICIENT_CREDITS: '余额或预算不足，请检查后重试。',
} as const;

export type AISessionBillingErrorCode = keyof typeof BILLING_ERROR_MESSAGES;
export const AI_SESSION_BILLING_ERROR_MESSAGES: Readonly<Record<string, string>> =
  BILLING_ERROR_MESSAGES;

/**
 * 同时覆盖 HTTP 402、预算校验的 HTTP 400 和持久化 Run 的费用拒绝码。
 */
export function isInsufficientCreditError(error: unknown): boolean {
  return getAISessionBillingErrorCode(error) !== undefined;
}

export function getAISessionBillingErrorCode(
  error: unknown
): AISessionBillingErrorCode | undefined {
  const code = getBusinessErrorCode(error);
  if (code && Object.hasOwn(AI_SESSION_BILLING_ERROR_MESSAGES, code))
    return code as AISessionBillingErrorCode;
  return getErrorCode(error) === 402 ? 'AI_SESSION_INSUFFICIENT_CREDITS' : undefined;
}
